<template>
    <modal-mask
        :opacity="maskOpacity"
        :close-trigger="closeTrigger"
        :closing="closing"
        @mount="mount"
    >
        <div ref="elModal" class="ActivityModal --docked-right" tabindex="-1" role="dialog">
            <div class="ActivityModal__header flex v-center">
                <div class="ActivityModal__title flex-1">
                    <slot name="title"></slot>
                </div>
                <button
                    type="button"
                    class="btn btn-sm btn-default"
                    aria-label="Close"
                    @click="close"
                >
                    <i class="fa fa-times"></i>
                </button>
            </div>

            <div class="ActivityModal__body">
                <page-loader :loading="loading">
                    <div v-if="items && items.length === 0">
                        <div class="alert alert-warning m-b-none">
                            <slot name="empty"></slot>
                        </div>
                    </div>

                    <div
                        v-for="item in items"
                        v-else-if="items"
                        :key="item.id"
                        class="ActivityModal__item"
                    >
                        <slot name="item" :item="item"></slot>
                    </div>
                </page-loader>
            </div>
        </div>
    </modal-mask>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.ActivityModal {
    outline: 0;
    position: fixed;
    z-index: 1050;
    top: 0;
    bottom: 0;
    margin: 0;
    height: 100vh;
    min-height: 100vh;
    width: 350px;
    max-width: 100%;

    background: #f5f8fa;
    border: none;
    border-radius: 0;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    transition: all ease-in 0.1s;

    &.--docked-right {
        right: 0;
    }

    .ActivityModal__header {
        position: sticky;
        top: 0;
        z-index: 1051;
        background: #fff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 15px;

        .ActivityModal__title {
            color: #7c7d7e;
            font-size: 12px;
            font-weight: bold;
            text-transform: uppercase;
        }
    }

    .ActivityModal__item {
        &:not(:first-child) {
            border-top: 1px dashed rgba(0, 0, 0, 0.1);
        }
    }
}

.ModalMask {
    &.modal-enter-active:not(.--restored) {
        .ActivityModal {
            right: -400px;
        }

        &.modal-enter-to .ActivityModal {
            right: 0;
        }
    }

    &.modal-leave-active:not(.--restored) {
        &.modal-leave-to .ActivityModal {
            right: -400px;
        }
    }
}
</style>

<script type="text/babel">
import { ReplaySubject } from 'rxjs'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import { delay } from 'rxjs/operators'
import HasEventListeners from 'dashboard-js/mixins/HasEventListeners'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import ModalMask from 'dashboard-js/components/ModalMask'
import TinyGesture from 'tinygesture'

export default {
    components: {
        ModalMask,
    },

    mixins: [HasEventListeners, HasSubscriptions],

    props: ['items'],

    data() {
        return {
            closeTrigger: new ReplaySubject(1),
            closing: new ReplaySubject(1),
        }
    },

    computed: {
        loading() {
            return typeof this.items === 'undefined' || this.items === null
        },

        maskOpacity() {
            return 0.5
        },
    },

    created() {
        this.subscribe(this.closeTrigger.pipe(delay(300)), () => this.$emit('close'))
    },

    beforeDestroy() {
        this.closing.next()
        this.gesture.destroy()

        clearAllBodyScrollLocks()
    },

    methods: {
        mount() {
            this.gesture = new TinyGesture(this.$refs.elModal, { mouseSupport: false })
            this.gesture.on('swiperight', this.close)

            disableBodyScroll(this.$refs.elModal, { reserveScrollBarGap: true })
        },

        close() {
            this.closeTrigger.next()
        },
    },
}
</script>
